import Vue from 'vue';
import VueRouter from 'vue-router';

// 甯冨眬 & 鐙珛椤甸潰
import MobileLayout from '@/layout/MobileLayout.vue';
import MyProfile from '@/views/wholesaler/MyProfile.vue';
import ShopInfo from '@/views/wholesaler/ShopInfo.vue';

Vue.use(VueRouter);

// 鍏堜繚瀛樺師鏉ョ殑鏂规硶
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;

// 閲嶅啓 push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch(err => {
    // 鍙妸鈥滈噸澶嶅鑸€濆拰鈥滆閲嶅畾鍚戔€濈殑閿欒鍚炴帀锛屽叾浠栭敊璇粛鐒舵姏鍑?
    if (
        err.name === 'NavigationDuplicated' ||
        (err.message && err.message.includes('Redirected when going'))
    ) {
      return err;
    }
    throw err;
  });
};

// 閲嶅啓 replace
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject);
  }
  return originalReplace.call(this, location).catch(err => {
    if (
        err.name === 'NavigationDuplicated' ||
        (err.message && err.message.includes('Redirected when going'))
    ) {
      return err;
    }
    throw err;
  });
};



const routes = [
  // ===== 鍏紑鍟嗗搧鏌ヨ锛堟棤闇€鐧诲綍锛?=====
  {
    path: '/',
    component: () => import('@/views/PublicProducts.vue'),
    meta: { requiresAuth: false, mobile: false }
  },
  {
    path: '/public/products',
    component: () => import('@/views/PublicProducts.vue'),
    meta: { requiresAuth: false, mobile: false }
  },
  // 分享落地页
  {
    path: '/share/:shareCode',
    name: 'ShareLanding',
    component: () => import('@/views/public/ShareLanding.vue'),
    meta: { requiresAuth: false, mobile: false }
  },
  // 游客模式 - 批发商店铺（通过ID访问，复用首页）
  {
    path: '/wholesale/:wholesalerId',
    name: 'WholesaleShop',
    component: () => import('@/views/PublicProducts.vue'),
    meta: { requiresAuth: false, mobile: false, title: '店铺浏览' }
  },
  // 批发商批量分享（公开访问）
  {
    path: '/s/b/:batchCode',
    name: 'BatchShare',
    component: () => import('@/views/public/BatchShareView.vue'),
    meta: { requiresAuth: false, mobile: true, title: '商品分享' }
  },
  // 批发商商品分享（公开访问）
  {
    path: '/s/p/:shareCode',
    name: 'SharedProduct',
    component: () => import('@/views/share/SharedProduct.vue'),
    meta: { requiresAuth: false, mobile: false, title: '商品详情' }
  },
  // 订单分享（公开访问）
  {
    path: '/s/o/:shareCode',
    name: 'SharedOrder',
    component: () => import('@/views/share/SharedOrder.vue'),
    meta: { requiresAuth: false, mobile: false, title: '订单详情' }
  },

  // ===== Auth pages (full screen, no layout) =====
  {
    path: '/login',
    component: () => import('@/views/Login.vue'),
    meta: { requiresAuth: false, mobile: false }
  },
  {
    path: '/register',
    component: () => import('@/views/Register.vue'),
    meta: { requiresAuth: false, mobile: false }
  },
  {
    path: '/auth/apple/callback',
    name: 'AppleCallback',
    component: () => import('@/views/auth/AppleCallback.vue'),
    meta: { requiresAuth: false, mobile: false }
  },
  {
    path: '/role-select',
    component: () => import('@/views/RoleSelect.vue'),
    meta: { requiresAuth: false, mobile: false }
  },
  {
    path: '/wholesaler-select',
    component: () => import('@/views/WholesalerSelect.vue'),
    meta: { requiresAuth: false, mobile: false }
  },

  // ===== 绠＄悊鍚庡彴璺敱 =====
  {
    path: '/admin/dashboard',
    component: () => import('@/views/admin/Dashboard.vue'),
    meta: { requiresAuth: true, role: 'ADMIN' }
  },
  {
    path: '/admin/users',
    component: () => import('@/views/admin/Users.vue'),
    meta: { requiresAuth: true, role: 'ADMIN' }
  },
  {
    path: '/admin/roles',
    component: () => import('@/views/admin/Roles.vue'),
    meta: { requiresAuth: true, role: 'ADMIN' }
  },
  {
    path: '/admin/features',
    component: () => import('@/views/admin/Features.vue'),
    meta: { requiresAuth: true, role: 'ADMIN' }
  },
  {
    path: '/admin/regions',
    component: () => import('@/views/admin/RegionManage.vue'),
    meta: { requiresAuth: true, role: 'ADMIN' }
  },
  {
    path: '/admin/category-audit',
    component: () => import('@/views/admin/CategoryAudit.vue'),
    meta: { requiresAuth: true, role: 'ADMIN' }
  },
  // 分享功能管理后台
  {
    path: '/admin/share-campaigns',
    name: 'AdminShareCampaigns',
    component: () => import('@/views/admin/ShareCampaigns.vue'),
    meta: { requiresAuth: true, role: 'ADMIN' }
  },
  {
    path: '/admin/share-rewards',
    name: 'AdminShareRewards',
    component: () => import('@/views/admin/ShareRewards.vue'),
    meta: { requiresAuth: true, role: 'ADMIN' }
  },
  {
    path: '/admin/share-stats',
    name: 'AdminShareStats',
    component: () => import('@/views/admin/ShareStats.vue'),
    meta: { requiresAuth: true, role: 'ADMIN' }
  },
  {
    path: '/admin/suppliers',
    component: () => import('@/views/admin/Suppliers.vue'),
    meta: { requiresAuth: true, role: 'ADMIN' }
  },
  {
    path: '/admin/stalls',
    component: () => import('@/views/admin/Stalls.vue'),
    meta: { requiresAuth: true, role: 'ADMIN' }
  },
  {
    path: '/admin/tax-rates',
    component: () => import('@/views/admin/TaxRateManage.vue'),
    meta: { requiresAuth: true, role: 'ADMIN' }
  },
  {
    path: '/admin/app-version',
    component: () => import('@/views/admin/AppVersionManage.vue'),
    meta: { requiresAuth: true, role: 'ADMIN' }
  },

  // ===== 妗ｅ彛璺敱锛堣€佺増 customer 鍏ュ彛锛?====
  {
    path: '/customer/home',
    component: () => import('@/views/customer/Home.vue'),
    meta: { requiresAuth: true, role: 'CUSTOMER' }
  },

  // ===== 鎵瑰彂鍟嗙嫭绔嬮〉闈紙涓嶈蛋 MobileLayout 鐨勫簳閮ㄥ鑸級=====
  {
    path: '/wholesaler/home',
    name: 'WholesalerHome',
    component: () => import('@/views/wholesaler/Home.vue'),
    meta: { requiresAuth: true, role: 'WHOLESALER' }
  },
  {
    path: '/wholesaler/order-on-behalf',
    name: 'OrderOnBehalf',
    component: () => import('@/views/wholesaler/OrderOnBehalf.vue'),
        meta: { requiresAuth: true, role: 'WHOLESALER', title: '代客下单' }
  },
  {
    path: '/wholesaler/product',
    name: 'ProductList',
    component: () => import('@/views/wholesaler/product/ProductList.vue'),
        meta: { requiresAuth: true, role: 'WHOLESALER', title: '商品管理' }
  },
  {
    path: '/wholesaler/my-products',
    name: 'MyProducts',
    component: () => import('@/views/wholesaler/MyProducts.vue'),
        meta: { requiresAuth: true, role: 'WHOLESALER', title: '我的商品' }
  },
  {
    path: '/wholesaler/product/:id',
    name: 'ProductDetail',
    component: () => import('@/views/wholesaler/product/ProductDetail.vue'),
        meta: { requiresAuth: true, role: 'WHOLESALER', title: '商品详情' }
  },
  {
    path: '/wholesaler/product/create',
    name: 'ProductCreate',
    component: () => import('@/views/wholesaler/product/ProductDetail.vue'),
        meta: { requiresAuth: true, role: 'WHOLESALER', title: '新建商品' }
  },
  {
    path: '/wholesaler/sub-categories',
    name: 'SubCategoryManage',
    component: () => import('@/views/wholesaler/SubCategoryManage.vue'),
        meta: { requiresAuth: true, role: 'WHOLESALER', title: '二级分类管理' }
  },
  {
    path: '/wholesaler/driver-management',
    name: 'DriverManagement',
    component: () => import('@/views/wholesaler/DriverManagementPage.vue'),
        meta: { requiresAuth: true, role: 'WHOLESALER', title: '配送员管理' }
  },
  {
    path: '/wholesaler/delivery-tasks',
    name: 'DeliveryTaskList',
    component: () => import('@/views/wholesaler/DeliveryTaskList.vue'),
        meta: { requiresAuth: true, role: 'WHOLESALER', title: '配送任务' }
  },
  {
    path: '/wholesaler/orders',
    name: 'WholesalerOrders',
    component: () => import('@/views/wholesaler/OrderList.vue'),
        meta: { requiresAuth: true, role: 'WHOLESALER', title: '订单管理' }
  },
  {
    path: '/wholesaler/orders/:id',
    name: 'WholesalerOrderDetail',
    component: () => import('@/views/wholesaler/WholesalerOrderDetail.vue'),
        meta: { requiresAuth: true, role: 'WHOLESALER', title: '订单详情' }
  },
  {
    path: '/wholesaler/after-sales',
    name: 'WholesalerAfterSales',
    component: () => import('@/views/wholesaler/AfterSalesList.vue'),
        meta: { requiresAuth: true, role: 'WHOLESALER', title: '售后管理' }
  },
  {
    path: '/wholesaler/after-sales/:id',
    name: 'WholesalerAfterSalesDetail',
    component: () => import('@/views/wholesaler/AfterSalesDetail.vue'),
        meta: { requiresAuth: true, role: 'WHOLESALER', title: '售后详情' }
  },
  {
    path: '/wholesaler/after-sales/:id/review',
    name: 'WholesalerAfterSalesReview',
    component: () => import('@/views/wholesaler/AfterSalesReview.vue'),
        meta: { requiresAuth: true, role: 'WHOLESALER', title: '售后审核' }
  },
  {
    path: '/wholesaler/after-sales/:id/pickup',
    name: 'AfterSalesPickup',
    component: () => import('@/views/wholesaler/AfterSalesPickupPage.vue'),
    meta: { requiresAuth: true, role: 'WHOLESALER', title: '取件确认' }
  },
  {
    path: '/wholesaler/after-sales/:id/return',
    name: 'AfterSalesReturn',
    component: () => import('@/views/wholesaler/AfterSalesReturnPage.vue'),
    meta: { requiresAuth: true, role: 'WHOLESALER', title: '退货质检' }
  },
  {
    path: '/wholesaler/after-sales/:id/refund',
    name: 'AfterSalesRefund',
    component: () => import('@/views/wholesaler/AfterSalesRefundPage.vue'),
    meta: { requiresAuth: true, role: 'WHOLESALER', title: '退款处理' }
  },
  {
    path: '/wholesaler/after-sales/:id/shipping',
    name: 'AfterSalesShipping',
    component: () => import('@/views/wholesaler/AfterSalesShippingPage.vue'),
    meta: { requiresAuth: true, role: 'WHOLESALER', title: '发货确认' }
  },
  {
    path: '/wholesaler/after-sales/:id/inspection-failed',
    name: 'AfterSalesInspectionFailed',
    component: () => import('@/views/wholesaler/AfterSalesInspectionFailed.vue'),
    meta: { requiresAuth: true, role: 'WHOLESALER', title: '质检异常' }
  },
  {
    path: '/wholesaler/wholesale-price-list',
    name: 'WholesalePriceList',
    component: () => import('@/views/wholesaler/WholesalePriceList.vue'),
    meta: { requiresAuth: true, role: 'WHOLESALER', title: '批发价管理' }
  },
  {
    path: '/wholesaler/create-package',
    name: 'CreatePackage',
    component: () => import('@/views/wholesaler/CreatePackage.vue'),
        meta: { requiresAuth: true, role: 'WHOLESALER', title: '创建批发报价' }
  },
  {
    path: '/wholesaler/warehouse',
    name: 'Warehouse',
    component: () => import('@/views/wholesaler/Warehouse.vue'),
        meta: { requiresAuth: true, role: 'WHOLESALER', title: '仓库管理' }
  },
  {
    path: '/wholesaler/stalls',
    name: 'StallManagement',
    component: () => import('@/views/wholesaler/StallManagement.vue'),
    meta: { requiresAuth: true, role: 'WHOLESALER', title: '档口管理' }
  },
  {
    path: '/wholesaler/stalls/add',
    name: 'StallAdd',
    component: () => import('@/views/wholesaler/StallAdd.vue'),
    meta: { requiresAuth: true, role: 'WHOLESALER', title: '添加档口' }
  },
  {
    path: '/wholesaler/printer-config',
    name: 'PrinterConfig',
    component: () => import('@/views/wholesaler/PrinterConfig.vue'),
        meta: { requiresAuth: true, role: 'WHOLESALER', title: '打印机设置' }
  },
  {
    path: '/wholesaler/receipt-print-config',
    name: 'ReceiptPrintConfig',
    component: () => import('@/views/wholesaler/ReceiptPrintConfig.vue'),
        meta: { requiresAuth: true, role: 'WHOLESALER', title: '打印小票设置' }
  },
  {
    path: '/wholesaler/stock-flow',
    name: 'StockFlowQuery',
    component: () => import('@/views/wholesaler/product/StockFlowQuery.vue'),
        meta: { requiresAuth: true, role: 'WHOLESALER', title: '库存流水查询' }
  },
  // 进货管理
  {
    path: '/wholesaler/purchase-list',
    name: 'PurchaseList',
    component: () => import('@/views/wholesaler/purchase/PurchaseList.vue'),
    meta: { requiresAuth: true, role: 'WHOLESALER', title: '进货管理' }
  },
  {
    path: '/wholesaler/purchase-create',
    name: 'PurchaseCreate',
    component: () => import('@/views/wholesaler/purchase/PurchaseCreate.vue'),
    meta: { requiresAuth: true, role: 'WHOLESALER', title: '新建进货单' }
  },
  {
    path: '/wholesaler/purchase-detail/:id',
    name: 'PurchaseDetail',
    component: () => import('@/views/wholesaler/purchase/PurchaseDetail.vue'),
    meta: { requiresAuth: true, role: 'WHOLESALER', title: '进货单详情' }
  },
  {
    path: '/wholesaler/purchase-return-list',
    name: 'PurchaseReturnList',
    component: () => import('@/views/wholesaler/purchase/PurchaseReturnList.vue'),
    meta: { requiresAuth: true, role: 'WHOLESALER', title: '退货单列表' }
  },
  {
    path: '/wholesaler/purchase-return-create',
    name: 'PurchaseReturnCreate',
    component: () => import('@/views/wholesaler/purchase/PurchaseReturnCreate.vue'),
    meta: { requiresAuth: true, role: 'WHOLESALER', title: '创建退货单' }
  },
  {
    path: '/wholesaler/purchase-return-detail/:id',
    name: 'PurchaseReturnDetail',
    component: () => import('@/views/wholesaler/purchase/PurchaseReturnDetail.vue'),
    meta: { requiresAuth: true, role: 'WHOLESALER', title: '退货单详情' }
  },
  {
    path: '/wholesaler/supplier-list',
    name: 'SupplierList',
    component: () => import('@/views/wholesaler/purchase/SupplierList.vue'),
    meta: { requiresAuth: true, role: 'WHOLESALER', title: '供应商管理' }
  },
  {
    path: '/wholesaler/supplier-form',
    name: 'SupplierForm',
    component: () => import('@/views/wholesaler/purchase/SupplierForm.vue'),
    meta: { requiresAuth: true, role: 'WHOLESALER', title: '供应商表单' }
  },
  // 营业报表
  {
    path: '/wholesaler/business-report',
    name: 'BusinessReport',
    component: () => import('@/views/wholesaler/report/BusinessReport.vue'),
    meta: { requiresAuth: true, role: 'WHOLESALER', title: '营业报表' }
  },
  // 应收报表
  {
    path: '/wholesaler/receivable-report',
    name: 'ReceivableReport',
    component: () => import('@/views/wholesaler/report/ReceivableReport.vue'),
    meta: { requiresAuth: true, role: 'WHOLESALER', title: '应收报表' }
  },
  // 企业所得税年度报表
  {
    path: '/wholesaler/income-tax-report',
    name: 'IncomeTaxReport',
    component: () => import('@/views/wholesaler/report/IncomeTaxReport.vue'),
    meta: { requiresAuth: true, role: 'WHOLESALER', title: '企业所得税报表' }
  },
  // GST 季度报表
  {
    path: '/wholesaler/gst-report',
    name: 'GstReport',
    component: () => import('@/views/wholesaler/report/GstReport.vue'),
    meta: { requiresAuth: true, role: 'WHOLESALER', title: 'GST季度报表' }
  },

  // ===== 配送员端页面 =====
  {
    path: '/driver/home',
    redirect: '/delivery'
  },
  {
    path: '/driver/contractor-hall',
    name: 'ContractorHall',
    component: () => import('@/views/driver/ContractorHall.vue'),
    meta: { requiresAuth: true, role: 'DRIVER', title: '抢单大厅' }
  },
  {
    path: '/my-profile',
    name: 'MyProfile',
    component: MyProfile,
    meta: { requiresAuth: true, role: 'WHOLESALER' }
  },
  {
    path: '/shop-info',
    name: 'ShopInfo',
    component: ShopInfo,
    meta: { requiresAuth: true, role: 'WHOLESALER' }
  },

  // ===== 鏂版。鍙ｏ紙Stall锛夌嫭绔嬮〉闈?=====
  {
    path: '/stall/home',
    redirect: '/stall/products'
  },
  // 妗ｅ彛鎵爜棰勮鎵瑰彂浠峰寘锛堝叕寮€璁块棶锛?
  {
    path: '/stall/wholesale-package/:id',
    name: 'StallWholesalePackage',
    component: () => import('@/views/Stall/WholesalePackage.vue'),
    meta: { requiresAuth: false, title: '批发价预订' }
  },
  // 鍏紑鍟嗗搧鍒楄〃锛堟湭鐧诲綍鍙闂級
  {
    path: '/products',
    name: 'PublicProductList',
    component: () => import('@/views/PublicProductList.vue'),
        meta: { requiresAuth: false, title: '商品列表' }
  },
  {
    path: '/stall/products',
    name: 'StallProducts',
    component: () => import('@/views/customer/StallProducts.vue'),
    meta: { requiresAuth: true, role: 'CUSTOMER' }
  },
  {
    path: '/customer/stall-products',
    name: 'CustomerStallProducts',
    component: () => import('@/views/customer/StallProducts.vue'),
    meta: { requiresAuth: true, role: 'CUSTOMER' }
  },
  // 商品搜索页面
  {
    path: '/customer/search',
    name: 'CustomerSearch',
    component: () => import('@/views/customer/SearchPage.vue'),
    meta: { requiresAuth: true, role: 'CUSTOMER' }
  },
  // 分享统计
  {
    path: '/customer/share-stats',
    name: 'ShareStats',
    component: () => import('@/views/customer/ShareStats.vue'),
    meta: { requiresAuth: true, role: 'CUSTOMER' }
  },
  {
    path: '/customer/checkout',
    name: 'CustomerCheckout',
    component: () => import('@/views/customer/Checkout.vue'),
    meta: { requiresAuth: true, role: 'CUSTOMER' }
  },
  // 配送员抢单大厅
  {
    path: '/delivery/grab-hall',
    name: 'GrabHall',
    component: () => import('@/views/Delivery/GrabHall.vue'),
    meta: { requiresAuth: true, roles: ['DRIVER'] }
  },
  // 配送员订单列表
  {
    path: '/delivery/orders',
    name: 'DriverOrderList',
    component: () => import('@/views/Delivery/OrderList.vue'),
    meta: { requiresAuth: true, roles: ['DRIVER'] }
  },
  // 配送员订单详情 → 复用批发商订单详情
  {
    path: '/delivery/orders/:id',
    name: 'DriverOrderDetail',
    component: () => import('@/views/wholesaler/WholesalerOrderDetail.vue'),
    meta: { requiresAuth: true, roles: ['DRIVER'] }
  },
  {
    path: '/delivery/order-on-behalf',
    name: 'DriverOrderOnBehalf',
    component: () => import('@/views/Delivery/OrderOnBehalf.vue'),
    meta: { requiresAuth: true, roles: ['DRIVER'], title: '代客下单' }
  },
  {
    path: '/delivery/profile',
    name: 'DriverProfile',
    component: () => import('@/views/Delivery/Profile.vue'),
    meta: { requiresAuth: true, roles: ['DRIVER'], title: '个人中心' }
  },
  // 鍦烘櫙 4锛氭。鍙ｆ壂鐮佷笅鍗曪紙H5锛?
  {
    path: '/h5/package/:token',
    name: 'H5PackageOrder',
    component: () => import('@/views/customer/H5PackageOrder.vue'),
    meta: { requiresAuth: false, title: '批发价专区' }
  },
  // 妗ｅ彛鎵爜涓嬪崟鍏ュ彛
  {
    path: '/stall/scan-qr',
    name: 'ScanQR',
    component: () => import('@/views/Stall/ScanQR.vue'),
        meta: { requiresAuth: true, role: 'CUSTOMER', title: '扫码下单' }
  },
  {
    path: '/stall/product/:id',
    name: 'StallProductDetail',
    component: () => import('@/views/Stall/StallProductDetail.vue'),
    meta: { requiresAuth: true, role: 'CUSTOMER' }
  },
  {
    path: '/stall/cart',
    name: 'StallCart',
    component: () => import('@/views/Stall/StallCart.vue'),
    meta: { requiresAuth: true, role: 'CUSTOMER' }
  },
  {
    path: '/stall/orders',
    name: 'StallOrders',
    component: () => import('@/views/Stall/StallOrders.vue'),
    meta: { requiresAuth: true, role: 'CUSTOMER' }
  },
  {
    path: '/stall/orders/:id',
    name: 'StallOrderDetail',
    component: () => import('@/views/Stall/StallOrderDetail.vue'),
    meta: { requiresAuth: true, role: 'CUSTOMER', title: '订单详情' }
  },
  {
    path: '/stall/after-sales',
    name: 'StallAfterSales',
    component: () => import('@/views/Stall/AfterSalesList.vue'),
    meta: { requiresAuth: true, role: 'CUSTOMER', title: '我的售后' }
  },
  {
    path: '/stall/after-sales/:id',
    name: 'StallAfterSalesDetail',
    component: () => import('@/views/Stall/AfterSalesDetail.vue'),
    meta: { requiresAuth: true, role: 'CUSTOMER', title: '售后详情' }
  },
  {
    path: '/stall/profile',
    name: 'StallProfile',
    component: () => import('@/views/Stall/StallProfile.vue'),
    meta: { requiresAuth: true, role: 'CUSTOMER' }
  },
  {
    path: '/stall/addresses',
    name: 'StallAddresses',
    component: () => import('@/views/Stall/AddressManage.vue'),
    meta: { requiresAuth: true, role: 'CUSTOMER' }
  },
  {
    path: '/stall/shop-info',
    name: 'StallShopInfo',
    component: () => import('@/views/Stall/StallShopInfo.vue'),
    meta: { requiresAuth: true, role: 'CUSTOMER' }
  },

  // ===== Protected routes with MobileLayout锛堝甫搴曢儴瀵艰埅锛?====
  {
    path: '/',
    component: MobileLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: { title: '首页', icon: '??' }
      },
      {
        path: 'shopping-cart',
        component: () => import('@/views/ShoppingCart/Index.vue'),
        meta: { title: '购物车', icon: '??' }
      },
      {
        path: 'purchase-order',
        component: () => import('@/views/PurchaseOrder/Index.vue'),
        meta: { title: '采购单列表', icon: '??' }
      },
      {
        path: 'purchase-order/create',
        component: () => import('@/views/PurchaseOrder/Create.vue'),
        meta: { title: '创建采购单', mobile: true }
      },
      {
        path: 'purchase-order/:id',
        component: () => import('@/views/PurchaseOrder/Detail.vue'),
        meta: { title: '采购单列表', icon: '??' }
      },
      {
        path: 'delivery',
        component: () => import('@/views/Delivery/Index.vue'),
        meta: { title: '发货管理', icon: '??' }
      },
      {
        path: 'stall',
        redirect: '/stall/dashboard'
      },
      {
        path: 'stall/dashboard',
        component: () => import('@/views/Stall/Dashboard.vue'),
        meta: { title: '摊位概览', icon: '??' }
      },
      {
        path: 'stall/inventory',
        component: () => import('@/views/Stall/Inventory/Index.vue'),
        meta: { title: '库存管理', icon: '??' }
      },
      {
        path: 'stall/purchase',
        component: () => import('@/views/Stall/Purchase/Index.vue'),
        meta: { title: '采购下单', icon: '??' }
      },
      {
        path: 'stall/sales',
        component: () => import('@/views/Stall/Sales/Index.vue'),
        meta: { title: '销售记录', icon: '??' }
      },
      {
        path: 'stall/return',
        component: () => import('@/views/Stall/Return/Index.vue'),
        meta: { title: '退货管理', icon: '??' }
      },
      {
        path: 'profile',
        component: () => import('@/views/Profile.vue'),
        meta: { title: '个人中心', icon: '??' }
      }
    ]
  },

  // ===== 404 / Not found =====
  {
    path: '*',
    component: () => import('@/views/NotFound.vue'),
    meta: { requiresAuth: false, title: '页面未找到' }
  },
  // ===== 403 / Forbidden =====
  {
    path: '/403',
    component: () => import('@/views/Forbidden.vue'),
        meta: { title: '无权限访问' }
  }
];

const router = new VueRouter({
  mode: window.Capacitor ? 'hash' : 'history',
  base: process.env.BASE_URL,
  routes
});

/**
 * 鏍规嵁 identity 閲嶅畾鍚戝埌瀵瑰簲棣栭〉
 */
function redirectByIdentity(identity) {
  switch (identity) {
    case 'ADMIN':
      return '/admin/dashboard';
    case 'STALL':
    case 'CUSTOMER':
    case 'SELLER':
      return '/stall/products';
    case 'WHOLESALER':
      return '/wholesaler/home';
    case 'DRIVER':
      return '/delivery/grab-hall';
    default:
      return '/login';
  }
}

// 璺敱瀹堝崼
router.beforeEach((to, from, next) => {
  const tokenKey = 'auth_token';
  const token = localStorage.getItem(tokenKey);
  const identity = localStorage.getItem('user_identity');

  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const isAuthPage = to.path === '/login' || to.path === '/register';

  // ⭐ 扫码入口：任何路径带 token/package_token，统一转去 /stall/cart
  const pkgToken = to.query.package_token || to.query.token;
  if (pkgToken && to.path !== '/stall/cart') {
    return next({ path: '/stall/cart', query: { package_token: pkgToken }, replace: true });
  }

  // 1）未登录访问需要认证的页面 → 跳转登录
  if (requiresAuth && !token) {
    return next({
      path: '/login',
      query: { redirect: to.fullPath },
      replace: true
    });
  }

  // 2）已登录访问登录/注册页 → 根据身份重定向到对应首页
  if (isAuthPage && token) {
    // 如果是从 login/register 页面跳转过来的，直接放行
    if (from.path === '/login' || from.path === '/register') {
      // ⭐ 如果来源页带 package_token/token（扫码），保留该参数跳转
      const pkgToken = from.query.package_token || from.query.token;
      if (pkgToken) {
        return next({ path: '/stall/cart', query: { package_token: pkgToken }, replace: true });
      }
      return next();
    }
    // identity 为空时放行，让角色选择页面处理
    if (!identity) {
      return next({ path: '/role-select', replace: true });
    }
    // ⭐ 如果 URL 带 package_token/token 参数（扫码），放行不重定向
    if (to.query.package_token || to.query.token) {
      return next();
    }
    const target = redirectByIdentity(identity);
    // 防止 target 又是 /login 导致死循环
    if (target === '/login') {
      return next({ path: '/role-select', replace: true });
    }
    return next({ path: target, replace: true });
  }

  // 3）前端不控制角色权限，交给后端 API 控制

  // 4）其他情况：放行
  next();
});

export default router;



